import { executeRequest, Request } from '@jfs/network'
import { AgentInfo } from '../data/models/Agent'
import { FundTransferApiProps } from '../data/models/Customer'
import { RootStore } from '../data/store'
import { generateRandomNumber, getNetworkResponseError, getUTCTimeStamp } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApi } from './sendEvent'

const responseParser = (
  data: any,
  type: 'balance_enquiry' | 'mini_statement' | 'cash_withdrawal' | 'cash_deposit' | 'fund_transfer',
  req: any,
) => {
  if (data?.data?.responseCode === '22413' || data?.code === '2369') {
    throw data
  } else if (data?.data?.error?.code === '2369') {
    throw data?.data?.error
  } else if (type === 'cash_withdrawal' || type === 'cash_deposit' || type == 'balance_enquiry') {
    const key = type === 'cash_deposit' ? 'payee' : 'payer'
    return {
      transactionId: data?.data?.responseData?.transaction?.transactionId,
      rrnNo: data?.data?.responseData?.transaction?.rrn,
      availableBalance: data?.data?.responseData?.account?.balance,
      bankName: req?.[key]?.bankName,
      mobileNo: req?.[key]?.mobile?.number,
      aadhaarNumber: req?.[key]?.aadhaar?.aadhaarNumber,
      amount: type === 'balance_enquiry' ? data?.data?.responseData?.account?.balance : req?.amount?.netAmount + '',
      message: getNetworkResponseError(data?.data).message,
      status: data?.data?.responseCode === '00' && data?.data?.responseMessage === 'SUCCESS' ? 'SUCCESS' : 'FAILURE',
      responseCode: data?.data?.responseCode,
      nextActionRequest: data?.data?.responseData?.transaction?.nextActionRequest,
    }
  } else if (type == 'mini_statement') {
    return {
      aadhaarNo: req?.payer?.aadhaar?.aadhaarNumber,
      bankName: req?.payer?.bankName,
      mobileNo: req?.payer?.mobile?.number,
      amount: data?.data?.responseData?.account?.balance,
      transactionTime: data?.data?.responseData?.transaction?.transactionTime,
      transactions: data?.data?.responseData?.miniStatement,
      status: data?.data?.responseCode === '00' ? 'SUCCESS' : 'FAILURE',
      responseCode: data?.data?.responseCode,
      failiureMessage: getNetworkResponseError(data?.data).message,
    }
  } else if (type == 'fund_transfer') {
    return {
      transactionId: data?.data?.responseData?.transaction?.transactionId,
      rrnNo: data?.data?.responseData?.transaction?.rrn,
      bankName: req?.payer?.bankName,
      amount: req?.amount?.netAmount + '',
      mobileNo: req?.payer?.mobile?.number,
      remittersAadhar: req?.payer?.aadhaar?.aadhaarNumber,
      remittersVID: req?.payer?.aadhaar?.aadhaarVirtualId,
      beneficiaryAadhar: req?.payee?.aadhaar?.aadhaarNumber,
      message: getNetworkResponseError(data?.data).message,
      status: data?.data?.responseCode === '00' && data?.data?.responseMessage === 'SUCCESS' ? 'SUCCESS' : 'FAILURE',
      responseCode: data?.data?.responseCode,
    }
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const executeTransaction = (
  tokens: any,
  req: any,
  type: 'balance_enquiry' | 'mini_statement' | 'cash_withdrawal' | 'cash_deposit' | 'fund_transfer',
) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.executeTransaction,
    //apiPath: 'http://10.162.6.163:9012/jpb/v1/aeps/payouts/transaction',
    method: 'POST',
    config: apiConfig(tokens),
    body: req,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
    transactionStage: `${type} - transaction completed`,
    biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
  })
  return executeRequest(request)
    .then((data) => {
      const parseData = responseParser(data, type, req)
      return parseData
    })
    .then((data) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
        referenceNumber: data.rrnNo,
        errorDescription: data.status === 'SUCCESS' ? null : data,
        transactionId: data.transactionId,
        transactionAmount: data.amount,
        transactionStage: `${type} - transaction completed`,
        biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
      })
      return data
    })
    .catch((err) => {
      const parseData = responseParser(err, type, req)

      try {
        sendEventApi(tokens, request, {
          status: 'FAILED',
          referenceNumber: parseData.rrnNo,
          errorDescription: parseData.status === 'SUCCESS' ? null : parseData,
          transactionId: parseData.transactionId,
          transactionAmount: parseData.amount,
          transactionStage: `${type} - transaction completed`,
          biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
        })
      } catch (error) {
        console.log('silent log error')
      }
      return parseData
    })
}

export const getBalanceRequest = (
  agent: typeof AgentInfo.properties,
  fingerPrintData: any,
  aadhaarNumber: string,
  bankId: string,
  bankName: string,
  mobileNo: string,
  aadhaarVirtualId: any,
  type: number,
  consentDetails?: any,
  amount?: string,
  authorizationCode?: string,
  otpReferenceId?: string
  // latitude?: string,
  // longitude?: string
) => {
  const randomNum = generateRandomNumber(16)
  return {
    transaction: {
      idempotentKey: randomNum,
      currency: 356,
      invoice: randomNum,
      method: {
        // "type": 312,BI
        type: type,
        subType: 550,
      },
      authorizationCode: authorizationCode,
      mode: 2,
      metadata: {
        // location: {
        //   latitude: latitude,
        //   longitude: longitude,
        // },
        agent: {
          id: agent.agentUserLoginId,
          subId: null,
          address: {
            stateCode: agent.agentUserDealerState,
            pinCode: agent.agentUserDealerPinCode,
          },
        },
      },
      captureMethod: 1,
      livemode: 'true',
      application: RootStore?.agent?.session?.CHANNEL_ID,
      initiatingEntityTimestamp: getUTCTimeStamp(),
      initiatingEntity: {
        entityId: RootStore?.agent?.session?.CHANNEL_ID,
        callbackUrl: null,
      },
    },
    ...((type === method.CASH_WITHDRAWAL || type === method.CASH_DEPOSIT || type === method.FUND_TRANSFER) && {
      amount: {
        netAmount: amount,
        grossAmount: amount,
      },
    }),
    [type === method.CASH_DEPOSIT ? 'payee' : 'payer']: {
      ...(mobileNo && {
        mobile: {
          number: mobileNo,
          countryCode: '91',
        },
      }),
      type: 13,
      userId: null,
      bankId: bankId,
      bankName: bankName,
      aadhaar: {
        ...(aadhaarNumber && { aadhaarNumber }),
        //aadhaarToken: '640e65d4b60693b0325ded419bc86d1564096942a4cfc1dd2648ebfd1132777cwllte0pf',
        ...(aadhaarVirtualId && { aadhaarVirtualId }),
        consentCode: {
          id: consentDetails?.consentTextCode,
          description: consentDetails?.text1,
          version: '1',
          timeStamp: getUTCTimeStamp(),
        },
      },
    },
    secure: {
      ...(type === method.CASH_WITHDRAWAL && otpReferenceId && { authenticationToken: otpReferenceId }),
      biometrics: {
        fingerprint: fingerPrintData,
      },
      deviceInfo: {
        peripheral: 'biometric device encrypted code',
        source: {
          type: 'MOB',
          id: RootStore?.agent?.deviceInfo?.id,
          ip: RootStore?.agent?.deviceInfo?.ip,
          osType: 'ANDROID',
          osVer: RootStore?.agent?.deviceInfo?.osVer,
          model: RootStore?.agent?.deviceInfo?.model,
        },
        location: {
          latitude: RootStore?.agent?.deviceInfo?.latitude,
          longitude: RootStore?.agent?.deviceInfo?.longitude,
        },
      },
    },
  }
}

export const getNextActionRequest = (
  nextActionTnx: any,
  aadhaarNumber: string,
  bankId: string,
  bankName: string,
  mobileNo: string,
  aadhaarVirtualId: string,
  consentDetails: any,
  amount?: string,
) => {
  const randomNum = generateRandomNumber(16)
  nextActionTnx.transaction.idempotentKey = randomNum
  return {
    ...nextActionTnx,
    amount: {
      netAmount: amount,
      grossAmount: amount,
    },

    payee: {
      ...(mobileNo && {
        mobile: {
          number: mobileNo,
          countryCode: '91',
        },
      }),
      type: 13,
      userId: null,
      bankId: bankId,
      bankName: bankName,
      aadhaar: {
        ...(aadhaarNumber && { aadhaarNumber }),
        //aadhaarToken: '640e65d4b60693b0325ded419bc86d1564096942a4cfc1dd2648ebfd1132777cwllte0pf',
        ...(aadhaarVirtualId && { aadhaarVirtualId }),
        consentCode: {
          id: consentDetails?.consentTextCode,
          description: consentDetails?.text1,
          version: '1',
          timeStamp: getUTCTimeStamp(),
        },
      },
    },
    secure: {
      biometrics: {
        fingerprint: 'fingerprint',
      },
      deviceInfo: {
        peripheral: 'biometric device encrypted code',
        source: {
          type: 'MOB',
          id: RootStore?.agent?.deviceInfo?.id,
          ip: RootStore?.agent?.deviceInfo?.ip,
          osType: 'ANDROID',
          osVer: RootStore?.agent?.deviceInfo?.osVer,
          model: RootStore?.agent?.deviceInfo?.model,
        },
        location: {
          latitude: RootStore?.agent?.deviceInfo?.latitude,
          longitude: RootStore?.agent?.deviceInfo?.longitude,
        },
      },
    },
  }
}

export const getFundTransferReq = (agent: typeof AgentInfo.properties, inputParms: FundTransferApiProps) => {
  const balReq: any = getBalanceRequest(
    agent,
    inputParms.fingerprintData,
    inputParms.aadhaarNumber,
    inputParms.bankId,
    inputParms.bankName,
    inputParms.mobileNo,
    inputParms.vid,
    method.FUND_TRANSFER,
    inputParms?.consentDetails,
    inputParms.amount,
    // latitude,
    // longitude
  )
  balReq.secure.biometrics.type = inputParms?.authMode === 'FACE' ? 3 : 1
  balReq.payee = {
    aadhaar: {
      //704401148858
      ...(inputParms.beneficieryAadhaar && { aadhaarNumber: inputParms.beneficieryAadhaar }),
      //aadhaarToken: '640e65d4b60693b0325ded419bc86d1564096942a4cfc1dd2648ebfd1132777cwllte0pf',
      ...(inputParms.beneficieryVid && { aadhaarVirtualId: inputParms.beneficieryVid }),
      //aadhaarToken: '640e65d4b60693b0325ded419bc86d1564096942a4cfc1dd2648ebfd1132777cwllte0pf',
      consentCode: {
        id: inputParms?.consentDetails?.consentTextCode,
        description: inputParms?.consentDetails?.text1,
        version: '1',
        timeStamp: getUTCTimeStamp(),
      },
    },
    bankId: inputParms.beneficieryBankId,
    bankName: inputParms.beneficieryBankName,
    type: 13,
  }
  return balReq
}

export const method = {
  CASH_WITHDRAWAL: 115,
  CASH_DEPOSIT: 217,
  MINI_STATEMENT_TYPE: 311,
  BALENCE_ENQUIRY_TYPE: 312,
  FUND_TRANSFER: 424,
}
